<template>
  <div class="bgBox" :style="{ height: height }">
    <div class="closeBox">
      选择买家<img
        class="close"
        @click="$emit('close')"
        src="../../assets/close.png"
      />
    </div>
    <div class="searchWrapper">
      <div class="searchBox">
        <div class="inputBox">
          <input
            v-if="type == 1"
            class="searchInput flex1"
            type="search"
            placeholder="请输入客户姓名或手机号"
            v-model="searchName"
          />
          <input
            v-else
            class="searchInput flex1"
            type="search"
            placeholder="请输入公司名称"
            v-model="searchName"
          />
        </div>
        <div class="search" @click="search">搜索</div>
      </div>
    </div>
    <div
      class="customerWrapper"
      style="position: absolute;top: 98px;bottom: 0;width: 100%;overflow:scroll"
    >
      <div class="customerBox" v-for="(res, index) in pageList" :key="index">
        <div class="name">
          <span v-if="type == 1" style="margin-right: 10px">
            <span v-if="res.realName">{{ res.realName }}</span>
            <span v-else>{{ res.name }}</span>
            <span v-if="res.idValidated == 0" class="idcard-identity unIdentity"
              >未认证</span
            >
          </span>
          <span v-else>
            <span style="margin-right: 10px">{{ res.companyName }}</span>
            <span v-if="res.active == 0" class="idcard-identity unIdentity"
              >未认证</span
            >
          </span>
        </div>
        <div class="phone">
          <img src="../../assets/iconPhone.png" />{{
            type == 1 ? res.phone : res.contactPhone
          }}
        </div>
        <div class="choose" @click="choose(res)">选择</div>
      </div>
      <div class="loadMore" v-show="clickAdd" @click="addMore">
        点击加载更多
      </div>
      <div class="loadMore" v-show="loadMore">
        <img src="../../assets/loading.gif" />加载中
      </div>
      <div class="loadMore" v-show="noMore">到底了~~</div>
    </div>
  </div>
</template>

<script>
import { getNoRoleList, getCompanyList } from "@/api/order.js";
export default {
  name: "pageList",
  data() {
    return {
      clickAdd: true,
      loadMore: false,
      noMore: false,
      pageList: [],
      params: {
        current: 0,
        realName: "",
        companyName: "",
        size: 20,
        type: ""
      },
      searchName: ""
    };
  },
  props: ["type"],
  computed: {
    height() {
      return document.body.clientHeight - 46 + "px";
    }
  },
  created() {
    this.pageList = [];
    this.params.type = this.type;
    this.getPageList();
  },
  mounted() {},
  methods: {
    getPageList() {
      this.clickAdd = false;
      this.loadMore = true;
      this.noMore = false;
      this.params.current += 1;
      let req;
      if (this.params.type == 1) {
        this.params.realName = this.searchName;
        this.params.companyName = "";
        req = getNoRoleList(this.params);
      } else {
        this.params.realName = "";
        this.params.companyName = this.searchName;
        req = getCompanyList(this.params);
      }
      req
        .then(res => {
          this.pageList = this.pageList.concat(res.records);
          if (res.current < res.pages) {
            this.clickAdd = true;
            this.loadMore = false;
            this.noMore = false;
          } else {
            this.clickAdd = false;
            this.loadMore = false;
            this.noMore = true;
          }
        })
        .catch(err => {
          this.$showMessage(err.message);
        });
    },

    addMore() {
      this.clickAdd = false;
      this.loadMore = true;
      this.noMore = false;
      this.getPageList();
    },

    search() {
      this.clickAdd = false;
      this.loadMore = true;
      this.noMore = false;
      this.params.current = 0;
      this.pageList = [];
      this.getPageList();
    },

    choose(res) {
      if (this.type == 1) {
        if (res.realName) {
          this.$emit("change", {
            clientId: res.id,
            companyId: null,
            name: res.realName,
            phone: res.phone
          });
        } else {
          if (res.name) {
            this.$emit("change", {
              clientId: res.id,
              companyId: null,
              name: res.name,
              phone: res.phone
            });
          } else {
            this.$emit("change", {
              clientId: res.id,
              companyId: null,
              name: res.phone,
              phone: res.phone
            });
          }
        }
      } else {
        const { userId, id, companyName, contactPhone } = res;
        this.$emit("change", {
          clientId: userId,
          companyId: id,
          name: companyName,
          phone: contactPhone
        });
      }
    },

    close() {
      this.$emit("closeBox", false);
    }
  }
};
</script>

<style scoped>
.search {
  width: 120px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-size: 14px;
}
.unIdentity {
  color: #eb8f8f;
  background: #feeeee;
  border: 1px solid #eb8f8f;
}
.idcard-identity {
  font-size: 10px;
  border-radius: 30px;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}
.closeBox {
  position: relative;
  width: 100%;
  height: 88px;
  background: #0376ec;
  line-height: 88px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.close {
  position: absolute;
  display: block;
  top: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
}
.bgBox {
  background-color: #fff;
  width: 100%;
  margin-top: 92px;
}

.loadMore {
  margin: 36px 0;
  text-align: center;
  font-size: 14px;
}

.loadMore img {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 20px;
}

.searchBox {
  overflow: hidden;
  height: 64px;
  margin: 20px;
  padding: 0 10px;
  display: flex;
}
.searchWrapper {
  background: #fff;
  overflow: hidden;
  border-bottom: 1px solid #e6e6e6;
}

.searchIcon {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin: 16px 32px;
}

.inputBox {
  padding: 14px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #eee;
  flex: 1;
}

.searchInput {
  font-size: 14px;
  border: none;
}

.customerWrapper {
  width: 100%;
  background: #fff;
}

.customerBox {
  padding: 30px 0;
  margin: 0 30px;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
}

.name {
  font-size: 14px;
  color: #262626;
  height: 40px;
  line-height: 40px;
}

.phone {
  font-size: 14px;
  color: #777777;
  height: 40px;
  line-height: 40px;
}

.phone img {
  width: 32px;
  height: 32px;
  margin: 4px 0;
  display: inline-block;
  vertical-align: bottom;
}

.choose {
  position: absolute;
  top: 50px;
  right: 0;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  font-size: 12px;
  line-height: 40px;
  color: #fff;
  background: linear-gradient(59deg, #fab737, #ff8610);
}
.iconsousuo {
  font-size: 12px;
  line-height: 64px;
  margin-right: 10px;
}
</style>
